// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as JsBindings$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as DownloadAppStore$PorterinFeature from "../../../shared/download-app/constants/DownloadAppStore.mjs";

var get_data = DownloadAppStore$PorterinFeature.getDownloadData;

function isIOS(param) {
  var devices = [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod",
    "MacIntel"
  ];
  var userDevice = JsBindings$PorterinUtils.isBrowser(undefined) ? window.navigator.platform : "";
  if (JsBindings$PorterinUtils.isBrowser(undefined)) {
    return Js_array.includes(userDevice, devices);
  } else {
    return false;
  }
}

var download_app = {
  title: "Love what you see? ❤️",
  sub_title: "Get the best experience on our mobile app",
  qr_text: "Scan QR code to download the app",
  qr: {
    path: "https://dom-content-vault-prod-cdn-assets.porter.in/download_qr_code_790dca4b34/download_qr_code_790dca4b34.png",
    alt_text: "Download Porter App QR Code"
  }
};

export {
  get_data ,
  isIOS ,
  download_app ,
}
/* JsBindings-PorterinUtils Not a pure module */
